var locale = {
  placeholder: 'Selecteer tijd'
};
export default locale;
//# sourceMappingURL=nl_BE.js.map
